<template>
  <div class="main-content">
    <van-nav-bar
      class="immersive-nav"
      id="titlebar"
      fixed
      z-index="999"
      placeholder
      title="签到"
      left-arrow
      @click-left="onClickLeft"
    >
    </van-nav-bar>
    <div class="content">
      <div id="d-map" style="height: 200px"></div>
      <div
        style="
          flex: 1;
          height: 100%;
          display: flex;
          overflow: auto;
          flex-direction: column;
        "
      >
        <van-row>
          <van-field
            v-model="signInfo.signAddress"
            rows="1"
            type="textarea"
            autosize
            label-width="50"
            label="地址"
            required
            readonly
            right-icon="location-o"
            placeholder=""
            @click="handleLocation"
          />
          <van-field
            v-model="signInfo.signRemark"
            rows="3"
            type="textarea"
            autosize
            label-width="50"
            label="备注"
            :border="true"
            :required="signInfo.signType === 2"
            placeholder="请填写备注"
            label-align="top"
          />
        </van-row>

        <div
          style="
            display: flex;
            flex-direction: column;
            padding: 10px 20px;
            background-color: #fff;
          "
        >
          <span :class="signInfo.signType === 2 ? 'mark' : ''">签到图片</span>
          <van-uploader
            v-model="fileList"
            multiple
            :max-count="1"
            accept="image/*"
            capture="camera"
            upload-text="上传图片"
            :before-read="beforeRead"
            :after-read="afterRead"
            style="margin-top: 10px"
          />
        </div>

        <div
          style="
            display: flex;
            flex-direction: column;
            height: 200px;
            min-height: 200px;
            align-items: center;
            justify-content: center;
          "
        >
          <van-button
            round
            color="#1989FA"
            :disabled="!signInfo.signConfId"
            style="
              --van-button-round-radius: 100px;
              width: 130px;
              height: 130px;
            "
            @click="onClickSignIn"
          >
            <div style="display: flex; flex-direction: column; gap: 15px">
              <span style="font-size: 18px; font-weight: 700">{{
                signInfo.signType === 1 ? "内勤签到" : "外勤签到"
              }}</span>
              <span>{{ currTime }}</span>
            </div>
          </van-button>
          <span style="margin-top: 10px; color: #969799"
            >今日已签到
            <span style="color: #323233">{{
              ` ${signInCount ?? 0}次`
            }}</span></span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from "vue";
import { useRouter } from "vue-router";
import moment from "moment";
import AMapLoader from "@amap/amap-jsapi-loader";
import { getSignConfigInfo, signIn } from "@/api/sign";
import { showToast, showLoadingToast, closeToast } from "vant";
import { uploadFile } from "@/api/common";
import { userAuthStore } from "@/store/auth";
import {
  addWatermark,
  base64ToFile,
  convasToImg,
  fileByBase64,
  imgToCanvas,
} from "@/utils/system";

const router = useRouter();
const cityCode = ref("");
const store = userAuthStore();
// map对象
let map = null;
// 定位结果
const locResult = ref(null);
const currTime = ref(moment().format("HH:mm:ss"));
let timer = null;
const signInfo = reactive({
  signAddress: "", // 定位地址
  signAddressLon: "0", // 经度
  signAddressLat: "0", // 纬度
  signAddressRanage: 0, // 考勤有效范围，单位米
  signConfId: "", // 考勤配置ID
  signDistance: 10, // 签到距离，单位米
  signImage: null,
  signRemark: null, //签到备注
  signTime: moment(Date.now()).format("YYYY-MM-DD HH:mm:ss"), // 签到时间
  signType: 2, // 签到类型，1:内勤；2:外勤
});
const locationAddress = ref("");
const remarks = ref("");

// 图片
const fileList = ref([]);

const configInfo = ref(null);
const signInCount = ref(0);
const onClickLeft = () => {
  store.locationInfo = null;
  window?.flutter_inappwebview?.callHandler("goBackToApp", null);
};

// 重置签到数据用户填写的部分
const resetSignInfo = () => {
  signInfo.signImage = "";
  signInfo.signRemark = "";
  fileList.value = [];
  store.locationInfo = null; // 如果有微调地址，置空
  // 恢复定位数据
  if (locResult.value?.address) {
    signInfo.signAddress = locResult.value?.address ?? "定位失败";
    signInfo.signAddressLon = locResult.value?.longitude;
    signInfo.signAddressLat = locResult.value?.latitude;
  } else {
    handleReceiveLocation();
    window?.flutter_inappwebview?.callHandler("reqLocation", null);
  }
};
// 点击签到
const onClickSignIn = () => {
  const time1 = store.locationInfo?.locTime;
  const time2 = moment();
  const diffTimes = time2.diff(time1, "minute");
  console.log(
    "diff times ============",
    JSON.stringify(store.locationInfo),
    time2
  );
  showSuccessToast("diff==>" + diffTimes);
  // if (
  //   signInfo.signType === 2 &&
  //   (!signInfo.signRemark || !signInfo.signImage)
  // ) {
  //   console.log("click sign===>>", JSON.stringify(locResult.value));
  //   showToast("外勤签到必须填写备注和上传签到图片");
  //   return;
  // }
  // showLoadingToast({
  //   duration: 0,
  //   forbidClick: true,
  //   message: "正在加载",
  // });
  // signInfo.signTime = moment().format("YYYY-MM-DD HH:mm:ss");

  // signIn(signInfo)
  //   .then((res) => {
  //     resetSignInfo();
  //     signInCount.value = signInCount.value + 1;
  //     closeToast();
  //     showSuccessToast("签到成功");
  //   })
  //   .catch((error) => {
  //     closeToast();
  //     showFailToast(error ?? "签到失败");
  //   });
};

// 跳转到地点微调页面
const handleLocation = () => {
  const obj = {
    centerLng: signInfo?.signAddressLon,
    centerLat: signInfo?.signAddressLat,
    cityCode: cityCode.value,
    ranage: signInfo?.signAddressRanage ?? 100,
  };
  // const obj = {
  //   centerLng: "86.165989",
  //   centerLat: "41.723635",
  //   cityCode: "0996",
  //   ranage: signInfo.signAddressRanage,
  // };
  console.log("jump to relocation", JSON.stringify(obj));
  // 跳转到审批页面 (待处理)
  router.push({
    name: "relocation",
    params: { locationInfo: JSON.stringify(obj) },
  });
};
// 上传前，添加水印
const beforeRead = (file) => {
  console.log("before upload===111111111111111111=");
  return new Promise((resolve, reject) => {
    // 判断是否有摄像头权限
    // navigator.mediaDevices
    //   .getUserMedia({ video: true })
    //   .then((stream) => {
    //     console.log("van-uploader==stream=", JSON.stringify(stream));
    //   })
    //   .catch((err) => {
    //     console.log("van-uploader==err=", JSON.stringify(err));
    //   });
    fileByBase64(file, async (base64) => {
      // 把文件转换为Canvas
      let tempCanvas = await imgToCanvas(base64); // 2. 调用方法2：把base64转换为Canvas
      const markText = moment().format("yyyy年MM月DD日 HH点mm分ss秒");
      // 把水印写入
      const canvas = addWatermark(
        tempCanvas,
        markText,
        signInfo.signAddress ?? "定位失败"
      ); //3.调用方法3： 写入水印到Canvas
      // canvas转成img
      const img = convasToImg(canvas, file.type); //4. 调用方法4：把Canvas转换为image文件
      //被canvas转换为文件
      let newFile = base64ToFile(img.src, file.name); //5.调用方法5：被image转换为File文件
      resolve(newFile);
    });
  });
};

const afterRead = async (file) => {
  file.status = "uploading";
  file.message = "正在上传...";
  uploadFile(file)
    .then((res) => {
      signInfo.signImage = res;
      file.status = "done";
      showSuccessToast("图片上传成功");
    })
    .catch((error) => {
      console.log("upload error", error);
      file.status = "failed";
      file.message = "上传失败";
      showFailToast("图片上传失败");
    });
};

// 时间
const updateTimes = () => {
  const now = moment();
  currTime.value = now.format("HH:mm:ss");
};

onActivated(() => {
  console.log("==================sign page============onActivated===");
  handleReceiveLocation();
  if (store.locationInfo) {
    console.log("store.locationInfo", JSON.stringify(store.locationInfo));
    signInfo.signAddress = store.locationInfo?.address;
    signInfo.signAddressLon = store.locationInfo?.lon;
    signInfo.signAddressLat = store.locationInfo?.lat;
  } else {
    showLoadingToast({
      message: "定位中...",
      duration: 10 * 1000,
    });
  }
  initPage();
});

const addMarks = (markLat, markLon) => {
  var position = new AMap.LngLat(markLon, markLat);
  //创建一个 Marker 实例：
  const marker = new AMap.Marker({
    position: position, //经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
  });
  map?.setCenter(position);
  // 添加定位点标记
  map?.add(marker);
  // 判断打卡距离，如果超出配置范围，则为外勤打卡
  // 这里修改一下，签到配置点可能有多个，返回数组了
  /**
   * "signAddressList":[{"signAddress":"南昌世贸元亨","signAddressLon":"115.833198","sig
nAddressLat":"28.691221"}]
   */
  var p1 = [markLon, markLat];
  if (
    configInfo.value?.signAddressList &&
    configInfo.value?.signAddressList.length > 0
  ) {
    configInfo.value?.signAddressList.every((element) => {
      var p2 = [element?.signAddressLon ?? 0, element?.signAddressLat ?? 0];
      //返回 p1 到 p2 间的地面距离，单位：米
      var dis = AMap.GeometryUtil.distance(p2, p1);
      signInfo.signDistance = Number(dis).toFixed(0);
      if (dis > configInfo.value?.signAddressRanage) {
        // 外勤签到
        signInfo.signType = 2;
      } else {
        // 内勤签到
        signInfo.signType = 1;
        return false;
      }
    });
  }
};
// app定位回调方法
const handleReceiveLocation = () => {
  window.onLocationFail = function () {
    closeToast();
    showFailToast("定位失败");
  };
  window.receiveLocation = function (result) {
    closeToast();
    if (result) {
      locResult.value = JSON.parse(result);
      if (store.locationInfo) {
        signInfo.signAddress = store.locationInfo.address;
        signInfo.signAddressLon = store.locationInfo?.lon;
        signInfo.signAddressLat = store.locationInfo?.lat;
        store.locationInfo = {
          ...store.locationInfo,
          locTime: moment(),
        };
      } else {
        signInfo.signAddress = locResult.value?.address ?? "定位失败";
        signInfo.signAddressLon = locResult.value?.longitude;
        signInfo.signAddressLat = locResult.value?.latitude;
      }

      cityCode.value = locResult.value?.cityCode;
      addMarks(signInfo?.signAddressLat, signInfo?.signAddressLon);
    } else {
      showFailToast("定位失败");
    }
  };
};
// 初始化页面（获取考勤配置）
const initPage = async () => {
  timer = setInterval(updateTimes, 1000); // 每秒更新一次时间
  // 获取考勤配置
  await getSignConfigInfo()
    .then((res) => {
      if (res) {
        configInfo.value = res;
        signInCount.value = configInfo.value.daySignInCount ?? 0;
        // 考勤配置id，一定要配置
        signInfo.signConfId = res.signConfId;
        signInfo.signAddressRanage = res.signAddressRanage;
      }
    })
    .catch((error) => {
      console.log("getinfo error", error);
    });
  window._AMapSecurityConfig = {
    securityJsCode: "1cd106d13900dd493ac284004811d81b",
  };
  AMapLoader.load({
    key: "fb75cef02a4c2cb59359fbb8ce794739", // 申请好的Web端开发者Key，首次调用 load 时必填
    version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
  })
    .then((AMap) => {
      map = new AMap.Map("d-map", {
        // 设置地图容器id
        // viewMode: "3D", // 是否为3D地图模式
        resizeEnable: true,
        zoom: 15, // 初始化地图级别
        // center: [86.165839, 41.723385], // 初始化地图中心点位置
      });
      if (!store.locationInfo) {
        window?.flutter_inappwebview?.callHandler("reqLocation", null);
      } else {
        addMarks(store.locationInfo?.lat, store.locationInfo?.lon);
      }
    })
    .catch((e) => {
      console.log("location error", e);
    });
};

onUnmounted(() => {
  closeToast();
  map?.destroy();
  if (timer) {
    clearInterval(timer);
  }
});
</script>

<style scoped>
.main-content {
  width: 100%;
  height: calc(100% - 50px);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  font-size: 14px;
}

.content {
  flex: 1;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background-color: #f6f6f6;
}

#d-map {
  width: 100%;
  height: 200px;
  padding: 0px;
  margin: 0px;
}

.mark::before {
  content: "*";
  color: red;
  margin-right: 2px;
}

.immersive-nav {
  --safe-area-inset-top: env(safe-area-inset-top); /* 保留安全区域的距离 */
  padding-top: var(
    --safe-area-inset-top
  ); /* 添加额外的内边距以避免内容被状态栏遮挡 */
  .van-nav-bar__title {
    font-size: 18px; /* 根据需要调整标题字体大小 */
  }
  /* 可以添加更多自定义样式 */
}
</style>
